import React, { useState } from "react"

import Popup from "../../components/Popup"
import CustomTextField from "../../components/elements/TextField"
import { UI_LAYER_POPUP } from "../../constants/uiLayers"

import "pages/Styles/UIKit_v2.sass"
import "pages/Styles/ActivatePromoCodePopupV2.sass"

type Props = {
    onClose: () => void
    onActivate: (promoCode: string) => void
}

function ActivatePromoCodePopup({ onClose, onActivate }: Props) {
    const [promoCode, setPromoCode] = useState("")

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault()
        const trimmed = promoCode.trim()
        if (!trimmed) {
            return
        }
        onActivate(trimmed)
    }

    return (
        <Popup onClose={onClose} style={{ zIndex: UI_LAYER_POPUP }}>
            <form
                className="activate-promo-code-popup-v2 ui-kit-v2"
                onSubmit={handleSubmit}
            >
                <h2 className="activate-promo-code-popup-v2__title">
                    Активировать промо-код
                </h2>

                <div className="activate-promo-code-popup-v2__field">
                    <div className="activate-promo-code-popup-v2__label">Промо-код</div>
                    <CustomTextField
                        fullWidth
                        value={promoCode}
                        placeholder="Введите промо-код"
                        onChange={(e) => setPromoCode(e.target.value)}
                        autoFocus
                    />
                </div>

                <div className="activate-promo-code-popup-v2__actions">
                    <button
                        type="submit"
                        className="new ui-kit-v2-button activate-promo-code-popup-v2__submit action-button primary"
                        disabled={promoCode.trim().length === 0}
                    >
                        <span className="button-text">Активировать</span>
                    </button>
                </div>
            </form>
        </Popup>
    )
}

export default ActivatePromoCodePopup
